import { defineMessages } from 'react-intl';

export default defineMessages({
    dueDate: {
        id: 'billing.RecentPayment-table.Due Date',
        defaultMessage: 'Due Date'
    },
    billStatus: {
        id: 'billing.RecentPayment-table.Bill Status',
        defaultMessage: 'Bill Status'
    },
    lastPaymentDate: {
        id: 'billing.RecentPayment-table.Last Payment Date',
        defaultMessage: 'Last Payment Date'
    },
    invoiceTotal: {
        id: 'billing.RecentPayment-table.Invoice Total',
        defaultMessage: 'Invoice Total'
    },
    paid: {
        id: 'billing.RecentPayment-table.Paid',
        defaultMessage: 'Paid'
    },
    outstanding: {
        id: 'billing.RecentPayment-table.Outstanding',
        defaultMessage: 'Outstanding'
    },
    invoice: {
        id: 'billing.RecentPayment-table.Invoice Number',
        defaultMessage: 'Invoice Number'
    },
    pay: {
        id: 'billing.RecentPayment-table.Pay',
        defaultMessage: 'Pay'
    },
    noMatchingPayments: {
        id: 'billing.RecentPayment-table.No matching payments.',
        defaultMessage: 'No matching payments.'
    }
    
});
